import { Verification } from '@lib/iab/iab-vast-model';

import createFlashResource from './flash-resource';
import createJavaScriptResource from './javascript-resource';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const createVerification = ($verification: UnmarshalerNode): Verification => {
    const verification = new Verification();
    verification.vendor = $verification.vendor as string;

    if ($verification.javaScriptResource != null) {
        verification.javaScriptResources.push(
            ...($verification.javaScriptResource as UnmarshalerNode[]).map(
                (resource: UnmarshalerNode) =>
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    createJavaScriptResource(resource as any)
            )
        );
    }

    if ($verification.flashResource != null) {
        verification.flashResources.push(
            ...($verification.flashResource as UnmarshalerNode[]).map(
                (resource: UnmarshalerNode) =>
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    createFlashResource(resource as any)
            )
        );
    }

    // Note: viewableImpression and parameters are not standard properties
    // These are commented out as they don't exist in the Verification class

    return verification;
};

export default createVerification;
